import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OutOfTheOfficeAlert from '../components/OutOfTheOfficeAlert';
import { fetchOutOfTheOfficeStatusInfo } from '../actions/OutOfTheOfficeActions';
import { jsx as _jsx } from "react/jsx-runtime";
function NullableOutOfTheOffice({
  hubspotterName,
  outOfTheOffice
}) {
  const name = hubspotterName.split(' ')[0];
  return outOfTheOffice.outOfTheOffice && !outOfTheOffice.loading ? /*#__PURE__*/_jsx(OutOfTheOfficeAlert, {
    name: name,
    outOfTheOffice: outOfTheOffice
  }) : null;
}
const OutOfTheOfficeAlertContainer = props => {
  const {
    hubspotterId,
    hubspotterName
  } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    dispatch(fetchOutOfTheOfficeStatusInfo(hubspotterId));
  }, [dispatch, hubspotterId]);
  const outOfTheOffice = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.outOfTheOffice);
  return /*#__PURE__*/_jsx(NullableOutOfTheOffice, {
    hubspotterName: hubspotterName,
    outOfTheOffice: outOfTheOffice
  });
};
OutOfTheOfficeAlertContainer.propTypes = {
  hubspotterId: PropTypes.number.isRequired,
  hubspotterName: PropTypes.string.isRequired
};
export default OutOfTheOfficeAlertContainer;